const classPrefix = 'main-faq'
const dataPrefix = 'data-main-faq'
const $container = document.querySelector(`[${dataPrefix}]`)

if ($container)
{
    mainFaq();
}
export function mainFaq() {
    const wrapperAttr = 'data-main-faq-wrapper';
    const contentAttr = 'data-main-faq-wrap';

    const headers = document.querySelectorAll(`[${wrapperAttr}]`);

    headers.forEach(header => {
        header.addEventListener('click', () => {
            const id = header.getAttribute(wrapperAttr);
            const content = document.querySelector(`[${contentAttr}="${id}"]`);

            if (!content) return;

            const isOpen = content.classList.contains('is-open');

            header.classList.remove('is-open')
            // Закрываем все
            document.querySelectorAll(`[${contentAttr}]`).forEach(el => {
                el.classList.remove('is-open');
                el.style.maxHeight = null;
            });

            // Открываем, если был закрыт
            if (!isOpen) {
                content.classList.add('is-open');
                header.classList.add('is-open')
                content.style.maxHeight = content.scrollHeight + 'px';
            }
        });
    });
}
